export const calculatePayment = ({
  totalAmount,
  offerAmount = 0,
  specialOfferAmount = 0,
  rewardAmount = 0,
}) => {
  const finalAmount =
    totalAmount -
    offerAmount -
    specialOfferAmount -
    rewardAmount;

  return {
    originalAmount: totalAmount,
    offerAmount,
    specialOfferAmount,
    rewardAmount,
    finalAmount,
    totalSavings:
      offerAmount +
      specialOfferAmount +
      rewardAmount,
  };
};